import * as React from 'react'
import { Tabs as T, Tab as TabMui } from '@mui/material'
import Box from '@mui/material/Box'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

export const Tab = ({ index, children }: any) => <Box>{children}</Box>

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box component={'div'} sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const Tabs = React.forwardRef(({ tabs, onTabChange, children }: any, ref) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    onTabChange(newValue)
  }

  React.useImperativeHandle(ref, () => ({
    handleChange(value: any) {
      setValue(value)
      onTabChange(value)
    },
  }))

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <T
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {tabs.map((tab: any, index: number) => (
            <TabMui key={index} label={tab.label} {...a11yProps(index)} />
          ))}
        </T>
      </Box>
      {children?.map((component: any, index: number) => (
        <TabPanel value={value} index={index} key={index}>
          {component.props.children}
        </TabPanel>
      ))}
    </Box>
  )
})

export default Tabs
